export const AUTH_KEY = 'next-auth-t'

// export const MEDIA_BASE_URL =
//   process.env.NODE_ENV === 'development'
//     ? 'http://192.168.1.105:8000/media'
//     : 'https://sr.qnos.ir/media'

export const BASE_URL =
  process.env.NEXT_PUBLIC_NEXTAUTH_URL && process.env.NEXT_PUBLIC_NEXTAUTH_URL !== 'undefined'
    ? process.env.NEXT_PUBLIC_NEXTAUTH_URL
    : 'https://taalei-edu.ir/azkar/api'
